import React from 'react';
import T from 'prop-types';
import { get } from 'lodash-es';
import {
  Heading,
  Button,
  PlaybackList,
  PlaybackKey,
  Paragraph,
  Link,
} from '@piggybank/core';
import {
  Translation,
  TranslationScope,
  Optional,
} from 'srcAlias/client/locale';
import translations from 'contentAlias';
import useTrackPageViewAnalytics from 'srcAlias/client/global/customHooks/useTrackPageViewAnalytics';
import { useSelector } from 'react-redux';
import { selectQueryParams } from 'srcAlias/client/state/selectors';
import { isMobileJourney } from 'srcAlias/client/utils/urlParameters';
import { clickContinue } from 'srcAlias/client/utils/clickContinue';
import hooks from 'hooksAlias';
import config from 'configAlias';
export const TechnicalError = ({ segmentName, pageName }) => {
  useTrackPageViewAnalytics('technicalError');
  const queryParams = useSelector(selectQueryParams);
  const ErrorPageIcon = get(hooks, 'decision.error.ErrorPageIcon', () => null);
  return (
    <TranslationScope path={`${segmentName}.${pageName}`}>
      <ErrorPageIcon />
      <Heading level={1}>
        <Translation path="heading" />
      </Heading>
      <Paragraph>
        <Translation path="technicalErrorText" />
      </Paragraph>
      <Heading accentBar level={2}>
        <Translation path="whatCanIDo" />
      </Heading>
      <Paragraph>
        <Translation path="whatCanIDoText" />
      </Paragraph>
      <Heading level={3}>
        <Translation path="talkToUs" />
      </Heading>
      <PlaybackList type="review">
        <PlaybackKey>
          <Translation path="hsbcJade" />
        </PlaybackKey>
        <Paragraph>
          <Translation path="hsbcJadeValue" />
          <Optional>
            <div>
              <PlaybackKey>
                <Translation path="operationHoursMalaysia" />
              </PlaybackKey>
            </div>
          </Optional>
        </Paragraph>

        <PlaybackKey>
          <Translation path="premier" />
        </PlaybackKey>
        <Paragraph>
          <Translation path="premierValue" />
          <Optional>
            <div>
              <PlaybackKey>
                <Translation path="operationHoursPremier" />
              </PlaybackKey>
            </div>
          </Optional>
        </Paragraph>
        <PlaybackKey>
          <Translation path="hsbcPersonalBanking" />
        </PlaybackKey>
        <Paragraph>
          <Translation path="hsbcPersonalBankingValue" />
          <Optional>
            <div>
              <PlaybackKey>
                <Translation path="operationHoursAmanah" />
              </PlaybackKey>
            </div>
          </Optional>
        </Paragraph>
        <Optional>
          <PlaybackKey>
            <Translation path="inCountry" />
          </PlaybackKey>
          <Paragraph>
            <Translation path="inCountryValue" />
          </Paragraph>
          <PlaybackKey>
            <Translation path="abroad" />
          </PlaybackKey>
          <Paragraph>
            <Translation path="abroadValue" />
          </Paragraph>
        </Optional>
      </PlaybackList>
      <Optional>
        <Heading level={3}>
          <Translation path="getInTouch" />
        </Heading>
        <Paragraph>
          <Translation path="alternativelyTxt" />
          <Link
            external
            href={get(
              translations,
              'decision.technicalError.contactLinkUrl',
              '#'
            )}
            textMap={{ newWindow: <Translation path="textMap" /> }}
            name="requestCallbackLinkTechnicalErrorPage"
          >
            <Translation path="requestLinkTxt" />
          </Link>
          <Optional>
            <Translation path="alternativelyTxt2" />
          </Optional>
        </Paragraph>
      </Optional>
      {!isMobileJourney(queryParams) && (
        <Button
          onClick={() => clickContinue(pageName, __GOTOMYACCOUNT_URL__)}
          elementType="a"
          secondary={config.isSecondaryButton}
          target="_self"
          href={__GOTOMYACCOUNT_URL__}
        >
          <Translation path="goToMyAccount" />
        </Button>
      )}
    </TranslationScope>
  );
};

TechnicalError.propTypes = {
  segmentName: T.string,
  pageName: T.string,
};
